<template>
  <div>
    <div class="showcell">

      <div class="header">
        <!-- 图标 -->
        <div v-if="typeIcon === 'A' ">
          <div class="icon1">
          </div>
        </div>

        <div v-else-if="typeIcon === 'B' ">
          <div class="icon2">
          </div>
        </div>

        <div v-else-if="typeIcon === 'C' ">
          <div class="icon3">
          </div>
        </div>

        <div v-else-if="typeIcon === 'D' ">
          <div class="icon4">
          </div>
        </div>

        <div v-else>
          <div class="icon5">
          </div>
        </div>

        <p class="title" v-text="title"></p>
      </div>

      <div class="line">
      </div>
      <!-- 中间插槽内容 -->
      <div class="content">
        <slot>

        </slot>
      </div>
      <!-- 箭头 -->
      <!-- <div v-if="typeIcon === 'A' " v-tap="{methods:jump}">
        <div class="jump">
        </div>
      </div> -->

      <div v-if="typeIcon === 'B' " v-tap="{methods:jump}">
          <div class="jump">
          </div>
      </div>

      <div v-if="typeIcon === 'C' ">
        <router-link to="/record-aboutCourse">
          <div class="jump">
          </div>
        </router-link>
      </div>

      <div v-if="typeIcon === 'D' ">
        <router-link to="/record-completedCourse">
          <div class="jump">
          </div>
        </router-link>
      </div>
<!-- 
      <div v-if="typeIcon === 'E' ">
        <router-link to="/record-photo">
          <div class="jump">
          </div>
        </router-link>
      </div> -->




    </div>


  </div>

</template>

<script type="text/ecmascript-6">
  export default{
    methods: {
      jump () {
        // if (this.typeIcon === 'A') {
        //   this.$router.push({ path: '/record-new' });
        // }
        if (this.typeIcon === 'B') {
          this.$router.push({ path: '/record-TecComment' });
        }
      }
    },
    props: {
      typeIcon: {
        type: String
      },
      title: {
        type: String,
        default: '瓦酷教育'
      },
      recordModel: {
        type: Object
      }
    }
  };

</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .showcell{
    margin-left: px2rem(55);
    width: px2rem(600);
    height: px2rem(118);
    font-size: 0px;
  @include bg-img('../assets/img/parentRecord/recordBase');
  }
  .showcell:after{ display: block; clear:both; content: '';}
  .header{
    float: left;
    width: px2rem(136);
    padding-top: px2rem(18);
    padding-bottom: px2rem(5);


    .icon1{
      width: px2rem(54);
      height: px2rem(54);
      margin-left: px2rem(45);
      @include bg-img('../assets/img/parentRecord/Speaker-icon');
      }

    .icon2{
    width: px2rem(54);
    height: px2rem(54);
    margin-left: px2rem(45);
    @include bg-img('../assets/img/parentRecord/Twitter-Icon');
    }

    .icon3{
    width: px2rem(54);
    height: px2rem(54);
    margin-left: px2rem(45);

    @include bg-img('../assets/img/parentRecord/Menu-icon');
    }

    .icon4{
       width: px2rem(54);
       height: px2rem(54);
       margin-left: px2rem(45);
       background-color: red;
      @include bg-img('../assets/img/parentRecord/Leaderboard-icon');
     }
    .icon5{
      width: px2rem(54);
      height: px2rem(54);
      margin-left: px2rem(45);
      @include bg-img('../assets/img/parentRecord/t01c7165c9ec5252c5c');
    }

  }
  .title{
    padding-top: px2rem(5);
    font-size: px2rem(22);
    text-align: center;
    font-size: px2rem(22);
    color: rgba(255,255,255,1);
  }
  .line{
    float: left;
    width: px2rem(2);
    height: px2rem(80);
    margin-top: px2rem(15);
  @include bg-img('../assets/img/parentRecord/longstring');
  }
  .content{
    float: left;
    width: px2rem(340);
    height: px2rem(80);
    margin-left: px2rem(20);
    margin-top: px2rem(15);
    font-size: px2rem(30);

    overflow:hidden;
    /*text-align: center;*/




    /*text-overflow:ellipsis;*/
    /*white-space:nowrap;*/
    /*overflow:hidden;*/



  }
  .jump{
    float: right;
    width: px2rem(66);
    height: px2rem(66);
    margin-right: px2rem(20);
    margin-top: px2rem(25);



  @include bg-img('../assets/img/parentRecord/Arrow-icon');
  }


</style>



// WEBPACK FOOTER //
// VShowCell.vue?e31051e2